<template>
  <div />
</template>

<script>
import { logoutAndRedirect } from "@/utils";

export default {
  mounted() {
    logoutAndRedirect(this.$router);
  },
};
</script>
